// extracted by mini-css-extract-plugin
export default {"conflictList":"ConflictList_conflictList__KP1PJ"};